// `Navigator.connection` is part of the Network Information API but isn't in
// TS's default lib (still a draft spec). Type just the slice we read.
interface NavigatorWithConnection {
  connection?: { effectiveType?: string }
}

/**
 * Returns the effective network connection type as reported by the browser's
 * Network Information API. Server-side renders default to 'unknown'.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/effectiveType
 */
export function getConnection(): string {
  if (!import.meta.client) {
    return 'unknown'
  }

  const navigator = window.navigator as Navigator & NavigatorWithConnection

  return navigator?.connection?.effectiveType || 'unknown'
}
